import { render, staticRenderFns } from "./CallRules.vue?vue&type=template&id=9c4b4edc&scoped=true"
import script from "./CallRules.vue?vue&type=script&lang=js"
export * from "./CallRules.vue?vue&type=script&lang=js"
import style0 from "./CallRules.vue?vue&type=style&index=0&id=9c4b4edc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c4b4edc",
  null
  
)

export default component.exports